const defaultProcessor = require('./default');

module.exports = function (eventName, eventData) {
  INKIVE.Text._cache = {};
  return defaultProcessor.apply(this, arguments);
};
